import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/app-views-tabs.tsx");
